import { handleActions } from "redux-actions";
import { Set } from "immutable";
import {
    CART_ITEM_REQUEST,
    CART_ITEM_SUCCESS,
    CART_ITEM_FAILURE,
    CART_PRICING_SUCCESS,
    CART_PRICING_FAILURE,
    CART_FAILURE,
    CART_REQUEST,
    CART_PRICING_REQUEST,
    CART_RETOGGLE,
    CART_SUCCESS,
    CART_REDIRECT_AFTER_SUBMIT,
    CART_OPEN_CHECKOUT,
    CART_ITEM_ADD,
    CART_ITEM_REMOVE,
} from "constants/action-types";

const initialState = {
    items: new Set(),
    isFetchingItems: false,
    isFetchingPricing: false,
    entities: {},
    result: [],
    isFetching: false,
    error: undefined,
    errorMessage: undefined,
    forceRetoggle: false,
    onSubmitRedirectTo: "",
    orderedQuantities: undefined,
    isBulkOrder: false,
};

const cartReducer = handleActions(
    {
        [CART_REQUEST]: (state) => {
            return Object.assign({}, state, {
                isFetching: true,
                error: undefined,
            });
        },
        [CART_PRICING_REQUEST]: (state) => {
            return Object.assign({}, state, {
                isFetchingPricing: true,
                error: undefined,
            });
        },
        [CART_SUCCESS]: (state, { data }) => {
            const { entities, result, orderedQuantities, isBulkOrder } = data;
            return Object.assign({}, state, {
                isFetching: false,
                result: result,
                items: new Set(entities.orders[result].line_items),
                entities: entities,
                orderedQuantities,
                isBulkOrder,
            });
        },
        [CART_FAILURE]: (state, { error }) => {
            return Object.assign({}, state, { isFetching: false, error });
        },
        [CART_PRICING_SUCCESS]: (state, { data }) => {
            const { entities, result } = data;
            return Object.assign({}, state, {
                result,
                isFetchingPricing: false,
                entities: entities,
            });
        },
        [CART_PRICING_FAILURE]: (state, { error }) => {
            return Object.assign({}, state, { isFetchingPricing: false, error });
        },
        [CART_ITEM_REQUEST]: (state) => {
            return Object.assign({}, state, {
                items: state.items.clear(),
                isFetchingItems: true,
            });
        },
        [CART_ITEM_SUCCESS]: (state, { data }) => {
            return Object.assign({}, state, {
                isFetchingItems: false,
                items: new Set(data),
            });
        },
        [CART_ITEM_FAILURE]: (state) => {
            return Object.assign({}, state, {
                isFetchingItems: false,
                items: state.items.clear(),
            });
        },
        [CART_ITEM_ADD]: (state, { payload }) => {
            const items = state.items.add(payload);
            return Object.assign({}, state, { items });
        },
        [CART_ITEM_REMOVE]: (state, { payload, errorMessage }) => {
            const items = state.items.delete(payload);
            return Object.assign({}, state, { items, errorMessage });
        },
        [CART_RETOGGLE]: (state, { payload }) => {
            return {
                ...state,
                forceRetoggle: payload,
            };
        },
        [CART_REDIRECT_AFTER_SUBMIT]: (state, { payload }) => {
            return {
                ...state,
                onSubmitRedirectTo: payload,
            };
        },
        [CART_OPEN_CHECKOUT]: (state, { payload }) => {
            return {
                ...state,
                isCartCheckoutOpen: payload,
            };
        },
    },
    initialState
);

export default cartReducer;
